<top-banner variant="small"></top-banner>
<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">

        <div class="card-header">
          <h5 class="title">My Account</h5>
          <br>
          <h6 class="card-subtitle mb-2 text-muted">
            {{ globals.user.role | rolename }}
          </h6>
        </div>

        <div class="card-body">

          <form>
            <div class="form-group">
              <label>First Name</label>
              <input type="text" class="form-control" disabled="" placeholder="" value="{{ globals.user.firstName }}" />
            </div>

            <div class="form-group">
              <label>Last Name</label>
              <input type="text" class="form-control" disabled="" placeholder="" value="{{ globals.user.lastName }}" />
            </div>

            <div class="form-group">
              <label>Email</label>
              <input type="text" class="form-control" disabled="" placeholder="" value="{{ globals.user.email }}" />
            </div>

            <div class="form-group">
              <label>Login</label>
              <input type="text" class="form-control" disabled="" placeholder="" value="{{ globals.user.login }}" />
            </div>

            <div class="form-group">
              <label>Authorities</label><br />
              <span class="badge badge-info mr-2">Role #{{ globals.user.role }}</span>
              <ng-container *ngFor="let role of globals.user.authorities">
                <span class="badge badge-primary mr-2">{{ role.name }} </span></ng-container>
            </div>
          </form>

          <div class="menu-user">
            <div class="menu-user__border-spacer"></div>
          </div>

          <div class="d-flex justify-content-end">
            <div class="col-md-4">
              <button type="button" class="btn btn-round btn-block btn-primary" (click)="openChangePassword()">Change
                password</button>
            </div>
          </div>

        </div> <!-- end card-body -->

      </div>
    </div>

  </div>


  <div class="row menu-user">
    <div class="col-md-6">
      <signature-upload [user]="globals.user"></signature-upload>
    </div>
  </div> <!-- end signature card-->

</div>